import VideoLoader from "e.sic-platform.webclient/src/pages/analysis/components/VideoLoader";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { videoPlayerService } from 'e.sic-platform.webclient/src/services/video-player/VideoPlayerService';
import { ServiceStorage } from "e.sic-platform.webclient/src/services/app/ServiceStorage";

export default observer(function Player(props:{service:ServiceStorage, children:any}) {
    const {service} = props;

    useEffect(() => {
        videoPlayerService.loadVideoTimestamps(undefined);
        videoPlayerService.loadVideo(service.video!.videoUrl);
    }, [service.video, videoPlayerService.loadVideoTimestamps, videoPlayerService.loadVideo])

    return (
        <div style={{position: "relative"}}>
            <VideoLoader 
                canConvert={true}
                reloadFunction={service.load}
                video={service?.video}
            />
            {props.children}
        </div>
    )
})